import { render, staticRenderFns } from "./RealTimeVisits.vue?vue&type=template&id=70986d3a"
import script from "./RealTimeVisits.vue?vue&type=script&lang=js"
export * from "./RealTimeVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports